import { zodResolver } from "@hookform/resolvers/zod"
import { ReactNode, useEffect, useRef, useState } from "react"
import ReactDOM from "react-dom"
import { useForm } from "react-hook-form"
import ReactQuill from "react-quill"
import { useFindAllCustomMailsQuery, useRemoveMailMutation, useUpdateEmailMutation } from "../../../../features/mailsApi"
import { addBannerWithTimeout } from "../../../lib/centralizedBanner/slice"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import Button from "../../../ui/molecules/button"
import EditorInput from "../../../ui/molecules/editorInput/index copy"
import Input from "../../../ui/molecules/input"
import { Spinner } from "../../../ui/molecules/spinner"
import { AccordionTemplate } from "../../../ui/organisms/accordionTemplate"
import { ConfirmModal } from "../../../ui/organisms/confirmModal.tsx"
import { NotFound } from "../../../ui/organisms/notFound"
import { ProjectDTO } from "../dto"
import { setOpenTemplateId } from "./slice"
import { translateVariables, variablesMap } from "./utils"
import { TemplateFormValues, templateSchema } from "./validation"
import { TemplateDetails } from "./templateDetails"

interface Props {
    project: ProjectDTO
    updateTemplate: (html: string) => string[]
    stripHtml: (html: string) => string
}

export function Templates({ project, updateTemplate, stripHtml }: Props) {
    const [idToDelete, setIdToDelete] = useState<string | null>(null)
    const [removeTemplate] = useRemoveMailMutation()
    const handleRemoveTemplate = async () => {
        if (idToDelete) {
            try {
                await removeTemplate({ id: idToDelete }).unwrap()
                dispatch(addBannerWithTimeout({ message: "Template eliminato con successo", variant: "success" }))
                setIdToDelete(null)
            } catch (error) {
                dispatch(addBannerWithTimeout({ message: "Errore durante l'eliminazione del template", variant: "error" }))
            }
        }
    }

    const dispatch = useAppDispatch()

    const { data: customMails, isLoading } = useFindAllCustomMailsQuery({
        page: 0,
        pageSize: 0,
        sortBy: '1',
        projectId: project.id
    }, {
        skip: !project.id
    })

    return (
        <div className='h-[60vh] overflow-scroll w-full py-4 px-6 flex flex-col gap-2' key={1}>
            {
                isLoading &&
                <Spinner />
            }
            {
                customMails &&
                    customMails.data.length > 0 ?
                    customMails.data.map(item => <TemplateDetails key={item.id} template={item} setIdToDelete={setIdToDelete} />) :
                    <NotFound />
            }
            <ConfirmModal
                title={'Eliminazione template'}
                label={'Sei sicuro di voler eliminare questo template?'}
                confirmAction={() => {
                    handleRemoveTemplate()
                }}
                onClose={() => setIdToDelete(null)}
                visible={idToDelete !== null}
            />
        </div>
    )
}